var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEqifyMonochrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 76,
    viewBox: "0 0 173 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2166_42092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9869 52.8633V23.1338H77.554V25.9705H63.0941V36.5103H77.2834V39.348H63.0941V49.8878H77.6877V52.8602H59.9839L59.9869 52.8633ZM118.499 52.8633V23.1338H121.337V52.8633H118.499ZM156.069 52.8633V23.1338H158.906V52.8633H156.069ZM97.2847 49.8928C95.8105 49.857 94.3582 49.5279 93.0127 48.9246C91.6671 48.3213 90.4552 47.456 89.4477 46.3792C88.344 45.2859 87.475 43.9789 86.8938 42.5381C86.3127 41.0974 86.0317 39.5532 86.0679 38.0001C86.0314 36.4469 86.3123 34.9026 86.8935 33.4618C87.4747 32.0211 88.3438 30.7141 89.4477 29.6209C90.4888 28.5141 91.7448 27.6316 93.1389 27.0275C94.5331 26.4233 96.0359 26.1102 97.5553 26.1073C99.0787 26.0837 100.59 26.3849 101.988 26.9907C103.386 27.5965 104.638 28.4932 105.663 29.6209C106.767 30.7142 107.636 32.0213 108.217 33.462C108.798 34.9028 109.079 36.4469 109.043 38.0001C109.079 39.5532 108.798 41.0975 108.217 42.5383C107.636 43.9791 106.767 45.2861 105.663 46.3792C105.244 46.8174 104.792 47.2239 104.313 47.5954H108.503C109.423 46.4355 110.195 45.1644 110.799 43.8122C111.571 41.9751 111.939 39.9938 111.879 38.0021C111.86 36.0173 111.494 34.0511 110.799 32.192C110.053 30.4435 109.001 28.8424 107.692 27.4642C106.368 26.1153 104.812 25.016 103.098 24.2192C101.318 23.4032 99.3799 22.9877 97.4215 23.0021C95.5068 22.9877 93.6134 23.4036 91.881 24.2192C90.1673 25.0154 88.6111 26.114 87.2871 27.4622C85.9781 28.8406 84.9258 30.4416 84.1798 32.19C83.408 34.027 83.0396 36.0084 83.0995 38.0001C83.1189 39.9849 83.4845 41.951 84.1798 43.8101C84.9258 45.5585 85.9781 47.1596 87.2871 48.5379C88.611 49.8862 90.1672 50.9848 91.881 51.7809C93.57 52.5814 95.4156 52.9968 97.2847 52.997H112.96V49.8898L97.2847 49.8928ZM130.392 36.5123V52.8622H133.499V39.2152H146.202V36.5123H130.392ZM130.392 34.2169H133.499V25.8377H148.095V23.1348H130.391L130.392 34.2169Z",
    fill: "#0C2C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 23.1339V52.9991H36.828L36.7677 48.9604H19.0407V27.1715H44.8682V23.1328L15 23.1339Z",
    fill: "#0C2C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0724 35.3432H40.8668V40.0298H23.0623V44.1661H40.8668V52.9999H44.8652V31.207H23.0724V35.3432Z",
    fill: "#0C2C54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2166_42092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143.905,
    height: 30,
    fill: "white",
    transform: "translate(15 23)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqifyMonochrome);
export default __webpack_public_path__ + "static/media/eqifyMonochrome.826fbd2407898350d92feb4503300f16.svg";
export { ForwardRef as ReactComponent };